module.exports = __webpack_public_path__ + "img/problemsolver.00ed8520.svg";